import api from '../api'

export default {

  reps: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/reps?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  createGetData: async ()=> {
    return api.get('api/reps/create')
  },

  create: async rep => {
    return api.post('api/reps', rep)
  },

  get: async id => {
    return api.get('api/reps/' + id)
  },

  update: async (id,rep) => {
    return api.put('api/reps/' + id, rep)
  },

  delete: async id => {
    return api.delete('api/reps/' + id)
  }
}
